<template>
  <section class="echart-map">
    <div class="chart" ref="chart"></div>
  </section>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
import geoJson from '@/assets/china.json';

export default {
  name: 'echart-map',
  props: {},
  data() {
    return {
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    // 移除窗口监听事件
    // window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    async initChart() {
      // 注册地图
      echarts.registerMap('china', geoJson);
      // 初始化 ECharts 实例
      const chart = echarts.init(this.$refs.chart);
      let data = await this.getData()
      console.log(chart, data,  Math.min(...data.map(item => item.salesAmount)), Math.max(...data.map(item => item.salesAmount)))
      // 配置 ECharts 选项
      const option = {
        title: {
          // text: '中国各省人口统计',
          left: 'center'
        },
        tooltip: {
          show: false,
          trigger: 'item',
          // formatter: '{b}<br/>人口: {c} 万'
        },
        visualMap: {
          type: 'continuous',
          orient: 'horizontal',
          left: 'center',
          bottom: 20,
          min: Math.min(...data.map(item => item.salesAmount)),
          max: Math.max(...data.map(item => item.salesAmount)),
          text: ['高', '低'],
          inRange: {
            color: ['#00A0E9', '#EA5514']  // 低值和高值对应的渐变颜色
          },
          textStyle: {
            color: '#fff'
          },
          show: true
        },
        series: [
          {
            name: '销售额',
            type: 'map',
            map: 'china',
            roam: false,
            label: {
              show: true,
              fontSize: '8px',
              color: '#fff',
            },
            data: data, // 数据
            zoom: 1.2,
            itemStyle: {
              areaColor: 'transparent',
              borderColor: '#66ffff',
              shadowColor: 'rgba(7, 8, 27, 1)',
              shadowBlur: 20,
            },
            emphasis: {
              itemStyle: {
                areaColor: '#ff5722'
              }
            },
          }
        ]
      };

      // 设置配置项
      chart.setOption(option);
      setTimeout(() => {
        chart.resize();
      })
      // 监听窗口大小变化，动态调整图表大小
      window.addEventListener('resize', () => {
        chart.resize();
      });
    },
    async getData () {
      let res =await this.$http.get('regionSales/getRegionSales')
      // console.log(res.data.data, 8888)
      if (res.data.code === 200) {
        let data = res.data.data
        data.forEach(item => {
          item.name = item.provinceName
          item.value = item.salesAmount
        })
        return data
      }
    }
  },
};
</script>

<style scoped lang="scss">
.echart-map {
  width: 100%;
  .chart{
    width: 100%;
    height: 1000px;
  }
  @media (max-width: 768px) {
    .chart{
      width: 100%;
      height: 500px;
    }
  }
}
</style>
